import { DateFormat } from '@equip.health/ui';
import { union } from 'lodash';
import { DateTime } from 'luxon';
import { isoToLocalDateTime } from './date.util';

export const getActivityChangeKeys = (
  before: Record<string, any>,
  after: Record<string, any>,
): string[] => {
  const changedKeys: string[] = [];
  if (before && after) {
    union(Object.keys(before), Object.keys(after)).forEach((key) => {
      if (before[key] !== after[key]) {
        changedKeys.push(key);
      }
    });
  } else if (before) {
    Object.keys(before).forEach((key) => {
      if (before[key]) {
        changedKeys.push(key);
      }
    });
  } else if (after) {
    Object.keys(after).forEach((key) => {
      if (after[key]) {
        changedKeys.push(key);
      }
    });
  }
  return changedKeys;
};

export const getDisplayFieldsListLabel = (
  typeMapper: any,
  changeListKeys: string[],
): {
  key: string;
  value: string;
}[] =>
  changeListKeys
    .filter((key) => typeMapper?.[key])
    .map((key) => ({ key, value: typeMapper?.[key] }));

export const getDisplayFieldsList = (
  typeMapper: any,
  changeListKeys: string[],
): string[] => changeListKeys.filter((key) => typeMapper?.[key]);

export const isThisYear = (dateString: string): boolean => {
  const thisYear = DateTime.now().year;
  const yearFromDateString = DateTime.fromISO(dateString).year;
  return thisYear === yearFromDateString;
};

export const formatDisplayValue = (
  key: string,
  value: string | boolean | string[],
): string => {
  if (key === 'has_given_recording_consent' && value != null) {
    return value ? 'Consent given' : 'Consent not given';
  }
  if (Array.isArray(value)) {
    return value?.join(', ');
  }
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No';
  }
  if (key.includes('date') && value) {
    return DateTime.fromSQL(value).toLocaleString(DateTime.DATE_SHORT);
  }
  if (key === 'activityDate' && value) {
    return isoToLocalDateTime(value).toFormat(DateFormat.longDateWithTime);
  }
  return value || '--';
};
